(function(angular) {
    'use strict';

    // Important: this is not a completely generic utility,
    // there is some ui-bootstrap typeahead specific logic

    angular.module('aprima-core-ui').factory('ApReadonlyFindControl', [
        '$q',
        ApReadonlyFindControl,
    ]);
    
    function ApReadonlyFindControl(
        $q
    ) {
        var service = {
            init: init,
        };

        return service;

        function init(
            name,
            getItemByIdFn,
            searchFn,
            validationKey,
            templateUrl,
            idProperty,
            itemValidatorFn,
            removeDuplicateDefaults,
            onInitCtrlFn,
            getDefaultsFn,
            defaultHeader
        ) {

            if(!getItemByIdFn || !searchFn || !validationKey || !templateUrl) {
                throw new Error('Cannot init ApReadonlyFindControl from ' + name + ' without filling in required arguments');
            }

            var initCtrlCallback = onInitCtrlFn || angular.noop;
            var validator = itemValidatorFn ?
                itemValidatorFn :
                (idProperty ? defaultObjectValidator : defaultPrimitiveValidator);
            var getDefaultsCallback = getDefaultsFn || function() {
                return $q.when([]);
            };
            defaultHeader = defaultHeader || null;

            var directiveDefinition = {
                restrict: 'E',
                templateUrl: templateUrl,
                require: {
                    ngModel: 'ngModel',
                },
                scope: {},
                controllerAs: 'vm',
                bindToController: {
                    // expression to determine whether the control should be disabled or not
                    selectDisabled: '&',

                    // possible values:
                    // default-list="" == default-list="false"
                    // default-list="true" => use the directive's default (aka the default defined in apFindPharmacy)
                    // default-list="[1, 2, 3]"
                    // default-list="some expression returning a promise that resolves to an []"

                    // default list of items to show up (i.e. a patient's default list of pharmacies)
                    defaultList: '&?',
                    
                    // header that will show up above the defaultList
                    defaultHeader: '&?',

                    displayNone: '<?',

                    // if this expression evaluates to true, then it means the ngModel should represent the Id
                    // of the object rather than the whole thing
                    useId: '&',

                    // use this instead of ng-change with locals $id and $object
                    valueChanged: '&',

                    parentContainerId: '<?',
                },
                compile: ApReadonlyFindControlCompile,
                controller: [
                    '_',
                    '$element',
                    '$q',
                    '$qHelpers',
                    '$scope',
                    '$timeout',
                    '$window',
                    'DeviceSettings',
                    'uxConstants',
                    ApReadonlyFindControlCtrl,
                ],
            };

            return directiveDefinition;

            function ApReadonlyFindControlCompile(
                tElement
            ) {
                // set typeahead-focus-on-select to false so it doesn't focus the
                // input box again after selecting
                tElement.find('input').attr('typeahead-focus-on-select', false);
            }

            function ApReadonlyFindControlCtrl(
                _,
                $element,
                $q,
                $qHelpers,
                $scope,
                $timeout,
                $window,
                DeviceSettings,
                uxConstants
            ) {
                var vm = this;

                var tempViewValue = null;
                var noMatchingItem = false;
                var resetNgModelTimeout = null;

                vm.selectedItem = null;
                vm.placeHolderItem = null;
                vm.outstandingCalls = 0;

                vm.$onInit = onInit;
                vm.$onDestroy = onDestroy;
                vm.getDefaultHeader = getDefaultHeader;
                vm.callNoneAction = callNoneAction;


                function onInit() {
                    if(!idProperty) {
                        // ng-model represents whatever primitive item is picked
                        // $modelValue = 'someString'
                        // $viewValue = 'someString'
                        // or
                        // $modelValue = someNumber
                        // $viewValue = someNumber
                        // or it could work with object too, that for some reason doesn't have an id property
                        // $modelValue = { value: 'someValue' }
                        // $viewValue = { value: 'someValue' }

                        vm.ngModel.$formatters.push(formatOrParsePrimitive);
                        vm.ngModel.$parsers.push(formatOrParsePrimitive);
                        vm.ngModel.$viewChangeListeners.push(valueChangedPrimitive);
                    }
                    else if(vm.useId()) {
                        // ng-model represents the id of whatever item is picked
                        // $modelValue = 'objectId'
                        // $viewValue = {idProperty: 'objectId'}

                        if(_.isObject(vm.ngModel.$modelValue)) {
                            throw new Error('Cannot use an object as ng-model when using use-id="true" for ' + name);
                        }

                        vm.ngModel.$formatters.push(formatFromIdToObject);
                        vm.ngModel.$parsers.push(parseFromObjectToId);
                        vm.ngModel.$viewChangeListeners.push(valueChangedId);
                    }
                    else {
                        // ng-model represents the full object of whatever item is picked
                        // $modelValue = {idProperty: 'objectId'}
                        // $viewValue = {idProperty: 'objectId'}

                        vm.ngModel.$formatters.push(formatObject);
                        vm.ngModel.$parsers.push(parseObject);
                        vm.ngModel.$viewChangeListeners.push(valueChangedObject);
                    }

                    vm.ngModel.$render = render;


                    // have to listen for the event here rather than using ng-focus in the view because it gets fired earlier and i need
                    // to change the ngmodel before typeahead checks it in its own focus event
                    // and that is also why this needs to be $apply-ed instead of $evalAsync
                    $element.on('focus', 'input', inputFocus);

                    $element.on('blur', 'input', inputBlur);

                    vm.itemSelected = itemSelected;
                    vm.searchItems = searchItems;
                    vm.clear = clear;

                    initCtrlCallback(vm);
                }

                function onDestroy() {
                    $element.off('focus', 'input', inputFocus);
                    $element.off('blur', 'input', inputBlur);
                }

                // instead of actually changing anything in the ui in $render, pass the value along to the
                // inner input element
                function render() {
                    vm.selectedItem = vm.ngModel.$viewValue;
                    vm.placeHolderItem = vm.selectedItem;
                }

                function clear() {
                    // clear out everything: $viewValue, $modelValue, and call $render to set the selectedItem
                    vm.ngModel.$setViewValue(null);
                    vm.ngModel.$render();
                }

                function inputFocus() {
                    // empty the model that determines what the input shows, when focusing it
                    $scope.$apply(function() {
                        vm.placeHolderItem = vm.selectedItem;
                        vm.selectedItem = null;
                    });
                }

                function inputBlur() {
                    // reset the input on blur if there wasn't an item selected
                    $scope.$evalAsync(function() {
                        resetNgModelTimeout = $timeout(function() {
                            vm.ngModel.$rollbackViewValue();
                        }, uxConstants.blurDebounceTime);
                    });
                }

                function itemSelected($item) {
                    if(resetNgModelTimeout) {
                        // since an item was selected, cancel the timeout that would reset the model
                        // to its previous value
                        $timeout.cancel(resetNgModelTimeout);
                    }
                    vm.ngModel.$setViewValue($item);
                }

                function searchItems(text) {
                    if(DeviceSettings.isPhoneOrOverride) {
                        scrollToFit();
                    }

                    if(!text) {
                        // for now, if no text, then return the default list
                        var defaultListPromise = getDefaultList();
                        return defaultListPromise;
                    }

                    vm.outstandingCalls++;
                    var searchPromise = searchFn(text).finally(function() {
                        vm.outstandingCalls--;
                    });
                    return searchPromise;
                }
                
                function getItemById(id) {
                    vm.outstandingCalls++;
                    var promise = getItemByIdFn(id).finally(function() {
                        vm.outstandingCalls--;
                    });
                    return promise;
                }
                
                function getDefaultHeader() {
                    var header = (vm.defaultHeader && vm.defaultHeader()) || defaultHeader;
                    return header;
                }

                function callNoneAction() {
                    return itemSelected({});
                }

                function getDefaultList() {
                    var defaultList = vm.defaultList && vm.defaultList();
                    if(!defaultList) {
                        return $q.when([]);
                    }

                    var defaultsPromise = $q.when([]);
                    if(defaultList === true) {
                        defaultsPromise = getDefaultsCallback(vm);
                    }
                    else if(_.isArray(defaultList)) {
                        defaultsPromise = $q.when(defaultList);
                    }
                    else if($qHelpers.isPromise(defaultList)) {
                        defaultsPromise = defaultList;
                    }

                    vm.outstandingCalls++;

                    var resultPromise = defaultsPromise
                        .then(function(list) {
                            var defaultItemList = _.compact(list);

                            if(idProperty) {
                                // remove duplicates from defaultList if a track-by is used
                                // so angular won't throw an error
                                if(removeDuplicateDefaults) {
                                    defaultItemList = _.uniqBy(defaultItemList, idProperty);
                                }
                            }

                            defaultItemList.forEach(function(item) {
                                if(_.isObject(item)) {
                                    item.isDefault = true;
                                }
                            });

                            return defaultItemList;
                        })
                        .finally(function() {
                            vm.outstandingCalls--;
                        });

                    return resultPromise;
                }

                function parseFromObjectToId(value) {
                    if(!validator(value)) {
                        vm.ngModel.$setValidity(validationKey, false);
                        return null;
                    }

                    vm.ngModel.$setValidity(validationKey, true);

                    // return null instead of undefined, so it's not considered a parse error
                    // since we are already marking it as an error for a specific validationKey
                    return value ? value[idProperty] : null;
                }

                function formatFromIdToObject(value) {
                    // if there is no item matching this id then set a validation error
                    if(noMatchingItem) {
                        vm.ngModel.$setValidity(validationKey, false);
                        noMatchingItem = false;
                        return null;
                    }

                    vm.ngModel.$setValidity(validationKey, true);

                    if(!value) {
                        return null;
                    }

                    if(tempViewValue && tempViewValue[idProperty] === value) {
                        // a temp value was set before and now it can be returned to be passed on to the view
                        return tempViewValue;
                    }

                    // try to get the item associated with this id
                    getItemById(value).then(
                        function(result) {
                            if(!result || result[idProperty] !== value) {
                                // this is the same case as a request error (no matching item):
                                // because the result is null,
                                // or the id of the result for some reason doesn't match the id that was passed in
                                noMatchingItem = true;
                                result = null;
                            }

                            // if successful, then store it in a temp value
                            // and set the $modelValue to null to trigger the $formatter pipeline again
                            // from the internal ngModelWatch in NgModelController
                            // where it can then use this temp value as the actual object representing this id
                            vm.ngModel.$modelValue = null;
                            tempViewValue = result;
                        },
                        function() {
                            // if not successful, then set the temp value to null,
                            // set noMatchingItem to true,
                            // and set the $modelValue to null to trigger the $formatter pipeline again
                            // from the internal ngModelWatch in NgModelController
                            // where it can then set a validation error
                            noMatchingItem = true;
                            vm.ngModel.$modelValue = null;
                            tempViewValue = null;
                        }
                    );

                    // return the current $viewValue here so that there will be no view update since it
                    // needs to wait on a request to get the item matching the id in the $modelValue
                    // (the value passed into this method)
                    return vm.ngModel.$viewValue;
                }

                function valueChangedId() {
                    vm.valueChanged({
                        $id: vm.ngModel.$modelValue,
                        $object: vm.ngModel.$viewValue,
                    });
                }

                function formatObject(value) {
                    var isValid = validator(value);

                    if(!isValid) {
                        // ngModel object has idProperty, but the rest of the object isn't filled in
                        // so lookup the whole valid object
                        var objectId = value && value[idProperty];
                        if(objectId) {
                            return formatFromIdToObject(objectId);
                        }
                        // the ngModel object doesn't have valid idProperty, so it is completely invalid
                        // and cannot be filled in with a lookup
                        else {
                            vm.ngModel.$setValidity(validationKey, false);
                            return null;
                        }
                    }

                    vm.ngModel.$setValidity(validationKey, true);

                    return value || null;
                }

                function parseObject(value) {
                    if(!validator(value)) {
                        vm.ngModel.$setValidity(validationKey, false);
                        return null;
                    }

                    vm.ngModel.$setValidity(validationKey, true);

                    // return null instead of undefined, so it's not considered a parse error
                    // since we are already marking it as an error for a specific validationKey
                    return value || null;
                }

                function valueChangedObject() {
                    vm.valueChanged({
                        $id: vm.ngModel.$modelValue && vm.ngModel.$modelValue[idProperty],
                        $object: vm.ngModel.$modelValue,
                    });
                }

                function formatOrParsePrimitive(value) {
                    if(!validator(value)) {
                        vm.ngModel.$setValidity(validationKey, false);
                        return null;
                    }

                    vm.ngModel.$setValidity(validationKey, true);

                    // return null instead of undefined, so it's not considered a parse error
                    // since we are already marking it as an error for a specific validationKey
                    return value || null;
                }

                function valueChangedPrimitive() {
                    vm.valueChanged({
                        $id: vm.ngModel.$modelValue,
                        $object: vm.ngModel.$modelValue,
                    });
                }

                function scrollToFit() {
                    // try to better fit this input and results on the screen
                    $element.parent()[0].scrollIntoView();
                }
            }

            function defaultObjectValidator(value) {
                var isValid = !value || value[idProperty];
                return isValid;
            }

            function defaultPrimitiveValidator(value) {
                var isValid = !_.isNaN(value) && value !== '';
                return isValid;
            }
        }
    }

})(window.angular);
